// revenue.js
'use strict';
import { fromJS } from 'immutable';
import {
  MERGE_REVENUE_DATA,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Revenue.
 * @module reducer/revenue
 */
const revenue = (state = defaultState, action) => {
  switch (action.type) {
    case MERGE_REVENUE_DATA:
      return _MERGE_REVENUE_DATA(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 * add revenue data
 * @kind reducer/actionType
 * @name MERGE_REVENUE_DATA
 * @param {string[]} [selectPath] - select path to execute mergeDeepIn
 * @param {any} data - payload to execute mergeDeepIn/mergeDeep
 * @return {Immutable.Map} New state
 */
const _MERGE_REVENUE_DATA =
  ({ selectPath, data }) =>
  state => {
    if (selectPath == null) {
      return state.mergeDeep(fromJS(data));
    }
    return state.mergeDeepIn(selectPath, fromJS(data));
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default revenue;
